import request from '@/utils/request'

/**
 * 获得产品列表
 * @param {*} form
 */
export function list(form) {
	return request.post('/product/list', form);
}
/**
 * 获取专区ID
 * @returns 
 */
export function getSectionIds() {
	return request.post('/section/list');
}

export function productlistScore(form) {
	form.chanlCode = "BL";
	return request.post('/product/productlistScore', form);
}

/**
 * 获得产品详情
 * @param {*} form
 * 	-	id : 产品id
 */
export function detail(id) {
	return request.post('/product/detail', { id: id });
}

export function productCustomUrl(id) {
	return request.post('/product/productCustomUrl', { id: id })
}

/**
* 获取产品协议信息
* @param {*} productId 产品ID
* @param {*} id 协议ID
* @param {*} tradeAmount 交易金额
* @returns 
*/
export function getprotocol(productId, id, tradeAmount, attachRate, rateCouponIds) {
	return request.post('/product/getprotocol', { id: id, productId: productId, tradeAmount: tradeAmount, attachRate: attachRate, rateCouponIds: rateCouponIds });
}

/**
 * 获取拍卖资产协议信息
 * @param {*} productId 产品ID
 * @param {*} id 协议ID
 * @param {*} tradeAmount 交易金额
 * @param {*} type 类型：1 资产详情 2 资产买入页面
 * @returns 
 */
export function getAuctionProtocol(productId, id, tradeAmount, type) {
	return request.post('/product/getAuctionProtocol', { id: id, productId: productId, tradeAmount: tradeAmount, type: type });
}

/**
 * 获取拍卖资产确认书
 * @param {*} productId 产品ID
 * @returns 
 */
export function getAuctionConfirmFile(productId) {
	return request.post('/auction/getConfirmFile', { id: productId });
}

export function listtradeprotocol(typeId) {
	return request.post('/product/listtradeprotocol', { typeId: typeId });
}

export function canbuy(productId, tradeAmount) {
	return request.post('/product/canbuy', { productId: productId, tradeAmount: tradeAmount });
}

export function preview(productId) {
	return request.post('/product/preview', { id: productId });
}

//  获取虚拟产品
export function getProm() {
	return request.post('/product/getProm');
}

//  获取可领取体验券列表
export function showProm() {
	return request.post('/product/showProm');
}


//  领取体验券
export function receiveProm(data) {
	return request.post('/product/receiveProm', data);
}

//购买体验券
export function buyProm(activityDetail) {
	return request.post('/product/buyProm', { activityDetail });
}

/**
 * 获取体验金产品id
 * @returns 
 */
export function preExperienceProduct() {
	return request.post("/product/preExperienceProduct")
}

export function productIsPurchase() {
	return request.post("/product/isPurchase")
}

/**
 * 
 * @param {*} data  ustId target=order orderSn
 * @returns 
 */
export function getForward(data) {
	return request.post("/pyd/getForward", data)
}

export function queryPydData(data) {
	return request.post("/pyd/queryPydData", data)
}